import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';

import MacbookPro from './Macbookpro';
import CareerPulseLoader from './CareerPulseLoader';
import Chat from './Chat';
import CareerProgress from './CareerProgress';
import CareerLoader from './CareerProgressLoader';
import DiscoverCareers from './DiscoverCareers';
import DiscoverCareersLoader from './DiscoverCareersLoader';
import RoadmapLoader from './RoadmapLoader';
import Roadmap from './Roadmap';
import RecommendedSkillsLoader from './RecommendedSkillsLoader';
import RecommendedSkills from './RecommendedSkills';
import CareerVideosLoader from './CareerVideosLoader';
import CareerVideos from './CareerVideos';
import FutureSelfLoader from './FutureSelfLoader';
import FutureSelf from './FutureSelf';
import DailyQuoteLoader from './DailyQuoteLoader';
import DailyQuote from './DailyQuote';
import CareerTransitionLoader from './CareerTransitionLoader';
import CareerTransition from './CareerTransition';
import SoftSkillsLoader from './SoftSkillsLoader';
import SoftSkills from './SoftSkills';
import TimeoutScreen from './TimeoutScreen';
import StartupLoader from './StartupLoader';
import StartupPage from './StartupPage';
import LearnAndGrow from './LearnAndGrow';
import LearnGrowLoader from './LearnGrowLoader'; // Match your filename
import Layout from '../Components/Layout';
import Review from './Review';
import ThankYou from './ThankYou';


const App = () => {
  const location = useLocation();

  // Define routes that should have fade animation
  const animatedRoutes = ['/', '/career-pulse-loader'];

  const isAnimatedRoute = animatedRoutes.includes(location.pathname);

  return (
    <AnimatePresence mode="wait">
      {isAnimatedRoute ? (
        <motion.div
          key={location.pathname}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.4, ease: 'easeInOut' }}
        >
          <Routes location={location} key={location.pathname}>
            <Route path="/" element={<MacbookPro />} />
            <Route path="/career-pulse-loader" element={<CareerPulseLoader />} />
          </Routes>
        </motion.div>
      ) : (
        <Routes location={location} key={location.pathname}>
          <Route path="/" element={<Layout />}>
            <Route path="chat" element={<Chat />} />
            <Route path="career-progress-loader" element={<CareerLoader />} />
            <Route path="career-progress" element={<CareerProgress />} />
            <Route path="discover-careers-loader" element={<DiscoverCareersLoader />} />
            <Route path="discover-careers" element={<DiscoverCareers />} />
            <Route path="roadmap-loader" element={<RoadmapLoader />} />
            <Route path="roadmap" element={<Roadmap />} />
            <Route path="recommended-skills-loader" element={<RecommendedSkillsLoader />} />
            <Route path="recommended-skills" element={<RecommendedSkills />} />
            <Route path="career-videos-loader" element={<CareerVideosLoader />} />
            <Route path="career-videos" element={<CareerVideos />} />
            <Route path="/learn-and-grow-loader" element={<LearnGrowLoader />} />
<Route path="/learn-and-grow" element={<LearnAndGrow />} />
            <Route path="future-self-loader" element={<FutureSelfLoader />} />
            <Route path="future-self" element={<FutureSelf />} />
            <Route path="daily-quote-loader" element={<DailyQuoteLoader />} />
            <Route path="daily-quote" element={<DailyQuote />} />
            <Route path="career-transition-loader" element={<CareerTransitionLoader />} />
            <Route path="career-transition" element={<CareerTransition />} />
            <Route path="soft-skills-loader" element={<SoftSkillsLoader />} />
            <Route path="soft-skills" element={<SoftSkills />} />
            <Route path="timeout" element={<TimeoutScreen />} />
            <Route path="startup-loader" element={<StartupLoader />} />
            <Route path="startup" element={<StartupPage />} />
            <Route path="/review" element={<Review />} />
            <Route path="/thank-you" element={<ThankYou />} />

      
          </Route>
        </Routes>
      )}
    </AnimatePresence>
  );
};

export default App;
